/**
 * Helper to open the AgentE chat widget from anywhere in the app.
 *
 * The widget is lazily mounted (DeferredChatWidget), so we set a pending
 * flag in addition to dispatching the event: if the widget isn't mounted
 * yet, it checks the flag on mount and opens itself.
 */

declare global {
  interface Window {
    __agenteOpenPending?: boolean;
  }
}

export function openAgentE() {
  if (typeof window === "undefined") return;
  window.__agenteOpenPending = true;
  window.dispatchEvent(new Event("agente:open"));
}

export function consumeAgentEOpenPending(): boolean {
  if (typeof window === "undefined") return false;
  const pending = window.__agenteOpenPending === true;
  window.__agenteOpenPending = false;
  return pending;
}
